import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetSitesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportKpis/GetSites`,
	params: {}
});

export const GenerateReportRequest = (siteList, username, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}ReportKpis/GenerateReport`,
	data: { siteList, username, userId }
});

export const SyncTrackerRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}TrackerUpdate/UpdateTrackers`,
	params: {}
});

export const GetTrackerLastUpdateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportKpis/GetTrackerLastUpdate`,
	params: {}
});
